// CHANGE THE ENDPOINT FOR TARGET ENV
export const baseURL = process.env.NEXT_PUBLIC_APP_API_URL
  ? process.env.NEXT_PUBLIC_APP_API_URL
  : "https://my-staging.naikgaji.com";
export const assetDomain = "https://aset.naikgaji.com";
